import { MathHelper } from "./../helpers/mathHelper";

export class PercentageFormatValueConverter {
  toView(value: number, defaultValue: string) {
    return MathHelper.coerceValue(value, -1, 1, Number(defaultValue)) * 100;
  }
}
